import { Component, OnInit, Input } from '@angular/core';
import { PageConfiguration } from '../../../../models/page-configuration';

@Component({
  selector: 'app-what-is-idme',
  templateUrl: './what-is-idme.component.html',
  styleUrls: ['./what-is-idme.component.scss']
})
export class WhatIsIdmeComponent implements OnInit {
  @Input() pageConfig: PageConfiguration;

  constructor() { }

  ngOnInit() {
  }
}
